import * as React from 'react';
import { SVGProps } from 'react';

const IconPhoneSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.941 12.184A11.782 11.782 0 0 1 3.816 7.06l1.768-1.32a1 1 0 0 0 .375-1.031L5.265 1.77A1 1 0 0 0 4.292 1H1.778A.78.78 0 0 0 1 1.778C1 9.08 6.919 15 14.222 15a.78.78 0 0 0 .778-.778v-2.515a1 1 0 0 0-.768-.973l-2.939-.7a1 1 0 0 0-1.034.377l-1.318 1.773z" />
  </svg>
);
export default IconPhoneSizeS;
